import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  IWorkOrderSetting,
  IWorkOrderSettingRow,
} from '../../../../view/settings/api-automation-settings/work-order-settings/work-order-settings.model';
import { ProductCRUDInterface } from '../../../../shared/component/filter/filter.class';

export enum ActionTypes {
  WORK_ORDER_SETTINGS_DATA_LOADING = '[WORK_ORDER_SETTINGS] WORK_ORDER_SETTINGS DATA LOADING',
  WORK_ORDER_SETTINGS_DATA_LOADED = '[WORK_ORDER_SETTINGS] WORK_ORDER_SETTINGS DATA LOADED',
  GET_WORK_ORDER_SETTING = '[WORK_ORDER_SETTINGS] GET_WORK_ORDER_SETTING LOADING',
  GET_WORK_ORDER_SETTING_COMPLETED = '[WORK_ORDER_SETTINGS] GET_WORK_ORDER_SETTING COMPLETED',
  ADD_WORK_ORDER_SETTING = '[WORK_ORDER_SETTINGS] ADD_WORK_ORDER_SETTING',
  ADD_WORK_ORDER_SETTING_COMPLETED = '[WORK_ORDER_SETTINGS] ADD_WORK_ORDER_SETTING COMPLETED',
  EDIT_WORK_ORDER_SETTING = '[WORK_ORDER_SETTINGS] EDIT_WORK_ORDER_SETTING',
  EDIT_WORK_ORDER_SETTING_COMPLETED = '[WORK_ORDER_SETTINGS] EDIT_WORK_ORDER_SETTING COMPLETED',
  DELETE_WORK_ORDER_SETTINGS = '[WORK_ORDER_SETTINGS] DELETE_WORK_ORDER_SETTINGS',
  DELETE_WORK_ORDER_SETTINGS_COMPLETED = '[WORK_ORDER_SETTINGS] DELETE_WORK_ORDER_SETTINGS COMPLETED',
  CHANGE_ACTIVITIES_DATA_LOADING = '[WORK_ORDER_SETTINGS] CHANGE_ACTIVITIES DATA LOADING',
  CHANGE_ACTIVITIES_DATA_COMPLETED = '[WORK_ORDER_SETTINGS] CHANGE_ACTIVITIES DATA COMPLETED',
  HEARTBEAT_SETTINGS_DATA_LOADING = '[WORK_ORDER_SETTINGS] HEARTBEAT_SETTINGS DATA LOADING',
  HEARTBEAT_SETTINGS_DATA_COMPLETED = '[WORK_ORDER_SETTINGS] HEARTBEAT_SETTINGS DATA COMPLETED',
  PRODUCTS_DATA_LOADING = '[WORK_ORDER_SETTINGS] PRODUCTS DATA LOADING',
  PRODUCTS_DATA_COMPLETED = '[WORK_ORDER_SETTINGS] PRODUCTS DATA COMPLETED',
  FETCH_ERROR = '[WORK_ORDER_SETTINGS] FETCH ERROR',
}

export class WorkOrderSettingsLoading implements Action {
  readonly type = ActionTypes.WORK_ORDER_SETTINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class WorkOrderSettingsLoaded implements Action {
  readonly type = ActionTypes.WORK_ORDER_SETTINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IWorkOrderSetting>) {}
}

export class GetWorkOrderSetting implements Action {
  readonly type = ActionTypes.GET_WORK_ORDER_SETTING;

  constructor(public recordId: number) {}
}

export class GetWorkOrderSettingCompleted implements Action {
  readonly type = ActionTypes.GET_WORK_ORDER_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IWorkOrderSetting>) {}
}
export class AddWorkOrderSetting implements Action {
  readonly type = ActionTypes.ADD_WORK_ORDER_SETTING;

  constructor(
    public record: IWorkOrderSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddWorkOrderSettingCompleted implements Action {
  readonly type = ActionTypes.ADD_WORK_ORDER_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IWorkOrderSetting>) {}
}
export class EditWorkOrderSetting implements Action {
  readonly type = ActionTypes.EDIT_WORK_ORDER_SETTING;

  constructor(
    public recordId: number,
    public record: IWorkOrderSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditWorkOrderSettingCompleted implements Action {
  readonly type = ActionTypes.EDIT_WORK_ORDER_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IWorkOrderSetting>) {}
}
export class DeleteWorkOrderSettings implements Action {
  readonly type = ActionTypes.DELETE_WORK_ORDER_SETTINGS;

  constructor(public payload: number[]) {}
}

export class DeleteWorkOrderSettingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_WORK_ORDER_SETTINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ChangeActivitiesDataLoading implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING;
}

export class ChangeActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class HeartbeatSettingsDataLoading implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING;
}

export class HeartbeatSettingsDataCompleted implements Action {
  readonly type = ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class ProductsDataLoading implements Action {
  readonly type = ActionTypes.PRODUCTS_DATA_LOADING;
}

export class ProductsDataCompleted implements Action {
  readonly type = ActionTypes.PRODUCTS_DATA_COMPLETED;

  constructor(public payload: ProductCRUDInterface[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type WorkOrderSettingActions =
  | WorkOrderSettingsLoading
  | WorkOrderSettingsLoaded
  | GetWorkOrderSetting
  | GetWorkOrderSettingCompleted
  | AddWorkOrderSetting
  | AddWorkOrderSettingCompleted
  | EditWorkOrderSetting
  | EditWorkOrderSettingCompleted
  | DeleteWorkOrderSettings
  | DeleteWorkOrderSettingsCompleted
  | ChangeActivitiesDataLoading
  | ChangeActivitiesDataCompleted
  | HeartbeatSettingsDataLoading
  | HeartbeatSettingsDataCompleted
  | ProductsDataLoading
  | ProductsDataCompleted
  | FetchError;
